import { observer } from 'mobx-react-lite'
import { Tooltip } from 'shared/ui'
import { type ISwitchActionProps, SwitchAction } from 'shared/ui/SwitchAction'
import { type Campaign } from 'entities/Campaign'
import { toggleActiveCampaign } from 'pages/campaigns/actions/actionItems/toggleActiveCampaign'

type Props = {
  item: Campaign
  size?: ISwitchActionProps['size']
  className?: string
}

export const CampaignActiveToggle = observer(({ item, size = 'small', className }: Props) => (
  <div className={className}>
    <Tooltip label={item.isDraft && 'Complete required info to enable'} placement={'top'}>
      <SwitchAction
        size={size}
        active={item.status === 'active'}
        disabled={item.isDraft}
        onTrigger={() => toggleActiveCampaign(item)}
        ariaLabel={`CampaignActiveToggle-${item.id}`}
      />
    </Tooltip>
  </div>
))
